import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const EmailSend = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M18.1428 12.6159L11.417 15.4988C11.3053 15.5463 11.2095 15.6247 11.1409 15.725C11.0723 15.8252 11.0339 15.9429 11.0301 16.0643C11.0263 16.1857 11.0573 16.3056 11.1195 16.4099C11.1817 16.5142 11.2725 16.5985 11.381 16.6528L13.7532 17.8389L14.9393 20.2117C14.9936 20.3202 15.0779 20.4108 15.182 20.473C15.2862 20.5351 15.4059 20.5663 15.5271 20.5627C15.6484 20.5591 15.7661 20.521 15.8664 20.4528C15.9667 20.3846 16.0454 20.2892 16.0933 20.1777L18.9815 13.452C19.0321 13.3347 19.0463 13.205 19.0222 13.0796C18.9981 12.9542 18.9369 12.8389 18.8464 12.7488C18.756 12.6586 18.6405 12.5977 18.5151 12.574C18.3896 12.5504 18.2599 12.5649 18.1428 12.6159V12.6159Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.625 14.8125H4.6875C4.38913 14.8125 4.10298 14.694 3.892 14.483C3.68103 14.272 3.5625 13.9859 3.5625 13.6875V4.6875C3.5625 4.38913 3.68103 4.10298 3.892 3.892C4.10298 3.68103 4.38913 3.5625 4.6875 3.5625H18.1875C18.4859 3.5625 18.772 3.68103 18.983 3.892C19.194 4.10298 19.3125 4.38913 19.3125 4.6875V10.3125"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.0581 3.9751L12.9502 8.6731C12.5164 9.00674 11.9846 9.18764 11.4374 9.18764C10.8902 9.18764 10.3584 9.00674 9.92465 8.6731L3.81665 3.9751"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
